import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "./Sidebar";
import { Divider, Paper, Typography,LinearProgress, Backdrop, CircularProgress, Button } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import CountUp from "react-countup";
import Diversity3Icon from '@mui/icons-material/Diversity3';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import base from './base.json'


const drawerWidth = 80;
export class Ads extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      tab : 'one',
      is_loader_open : false,

       vendor_id : "",


        totalLeads: 0,
            totalTodayLeadsReceived: 0,


            /////////  payment setting details

      discount : 0,
      registration_amount : 0,
      activation_amount : 0,
      is_payment_accept : true

    
    }
  }
 



componentDidMount(){

 fetch(`${base.base_url}/admin/settings/retriveSettingDetails`, {
      headers: {
        "content-type": "application/json",
      },
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
      discount : result.data.discount,
      registration_amount : result.data.registration_amount,
      activation_amount : result.data.activation_amount,
      is_payment_accept : result.data.is_payment_accept
        });
      });

}



take_advertisement_subscription=()=>{
  
  
   let data = sessionStorage.getItem('data');

           const options = {
             key: base.api,
             amount: 100 *  this.state.registration_amount, 
             currency: "INR",
             name: "Ekbsapp Ads Subscription",
             description: "",
            
             handler: (response) => {
       
                
                   this.setState({is_loader_shows : true},()=>{
         fetch(`${base.base_url}/vendor/v_/take_advertisement_package_for_vender`, {
        
          headers: {
            "content-type": "application/json",
                    },
                                
        method: "post",
        body: JSON.stringify({
          id:JSON.parse(data)._id
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((d) => {
  
          alert("Subscription taken")
          
        }); 
      })
  
  
       
             },
             theme: {
               color: "#F37254",
             },
           };
       
           let rzp = new window.Razorpay(options);
           rzp.open();

}


  render() {


    return (
  
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
<Box sx={{height:'100%',width:'100%'}}>

{
  /// header data
}
<Box  sx={{height:47,width:'100%',backgroundColor:'#fff',borderRadius:0,mt:0.2,borderBottom:0.5,borderBottomColor:'#dddddd'}}>
<Tabs
  value={this.state.tab}
  onChange={this.handleChange}
  aria-label="wrapped label tabs example"
>
  <Tab
    value="one"
    sx={{textTransform:'none',fontWeight:'500',fontSize:15}}
    label="ADVERTISE HERE"
    wrapped
  />
</Tabs>
</Box>



{
  /// grid container
}
<Box sx={{paddingLeft:3,paddingRight:3,paddingTop:2,display:this.state.is_loader_open?'none':'block'}}>

<Box>
<Grid container spacing={1}>
  <Grid size={{xs:12,sm:6,md:2.4}}>

    <Paper sx={{width:'100%',height:110, background: '#3793ff'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'550',fontFamily:'sans-serif',color:'#fff'}}>TAKE ADVERTISEMENT PACKAGE</Typography>
        
        <Typography sx={{fontSize:15,fontWeight:'800',fontFamily:'sans-serif',color:'#fff',mt:1}}>₹ {this.state.registration_amount}/month</Typography>
       
         <Button onClick={this.take_advertisement_subscription} variant="contained" sx={{fontSize:12,mt:1,backgroundColor:'green'}}>TAKE SUBSCRIPTION</Button>

    </Box>
    </Paper>

  </Grid>



</Grid>
</Box>



{
  //// group division 
}

<Box sx={{mt:2,mb:2,display:'none'}}>

<Grid container spacing={3}>

<Grid size={{xs:12,sm:12,md:8}}>
<Box sx={{height:600,width:'100%',backgroundColor:'pink'}}>




</Box>
</Grid>
<Grid size={{xs:12,sm:12,md:4}}>
<Box sx={{height:600,width:'100%',backgroundColor:'red'}}>




</Box>
</Grid>

</Grid>


</Box>



































</Box>
</Box>

        </Box>




<Backdrop
  sx={(theme) => ({ color: '#fff',backgroundColor:'transparent',  zIndex: theme.zIndex.drawer + 1})}
  open={this.state.is_loader_open}
  onClick={this.handleClose}
>
<CircularProgress sx={{color:"#008ffb"}} />
</Backdrop>



      </Box>
   
    );
  }
}

export default Ads;



